// angular
import {Component, OnInit, ElementRef, Inject, OnDestroy} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

// services
import { SelfEvaluationService } from '../self-evaluation.service';
import { AuthService } from '../../core/auth.service';

// others
import { SelectionComponent } from '../selection.component';
import { AppService } from '../../app.service';
import {DOCUMENT} from "@angular/common";
import { TranslateService } from '@ngx-translate/core';
import { CoreService } from '../../core/core.service';
declare var window:any;

@Component({
    templateUrl: 'amnestic-smoke-detector.component.html',
    styleUrls: ['../self-evaluation.component.scss']
})
export class AmnesticSmokeDetectorComponent extends SelectionComponent implements OnInit, OnDestroy {
    currentStep: number;

    constructor(
        public elementRef: ElementRef,
        public service: SelfEvaluationService,
        public router: Router,
        public route: ActivatedRoute,
        public authService: AuthService,
        public appService: AppService,
        public coreService: CoreService,
        public translateService : TranslateService,
        @Inject(DOCUMENT) private document: Document
    ) {
        super(elementRef,service, router, route, authService, appService, coreService, translateService);
    }

    ngOnInit() {
        this.initStartTime();
        this.nextStep = false;
        this.noBackPlease();
        window.onbeforeunload = this.popupReload;
        window.onkeydown = this.preventBack;
        this.deviceInnerHeight = this.appService.deviceInnerHeight;
        this.lang = this.translateService.currentLang;
        this.setSEType();
        this.apiRoute = 'patient-questionnaire/' + this.pageTypes.se['route'] + '/' + this.pageTypes[this.appService.SEType]['smokeDetectorRoute'] + '/';
        this.apiUpdateRoute = 'patient-questionnaire/' + this.pageTypes.se['route'] + '/' + this.pageTypes[this.appService.SEType]['routeAnamPost'] + '/';

        // On Step 4 IsAcute = 0
        this.isAcute = 0;

        this.currentStep = this.appService.steps.ANAMESTIC_SELECTION;
        this.appService.setCurrentSeStep(this.currentStep);
        this.scrollToTop();
        this.route.params.subscribe(params => {
            this.token = params['token'];
            this.isLoading = true;
            this.apiRoute = this.apiRoute + this.token + '/' + this.isAcute + '/' +  this.layer + '/' + this.itemPerPage;
            this.service.getItems(this.apiRoute).subscribe((rs) => {
                this.isStudy = rs['is_study'];
                this.currentStep = rs['step'] || this.currentStep;
                this.appService.SEData.is_finish_first_repeated_step = rs['is_finish_first_repeated_step'];
                this.appService.setCurrentSeStep(this.currentStep);
                this.questionnaireId = rs['patient_questionnaire_id'];
                this.itemsGroup = rs['items'] || [];
                this.totalPage = rs['total_page'] || this.itemsGroup.length;

                if (rs['active_page'] < 1) {
                    this.activePage = 1;
                } else {
                    this.activePage = rs['active_page'] || 1;
                }
                this.getSelectedItemIds(rs['items']);
                this.groupSelectedCount[this.activePage] = this.calculateSelectedItem(this.selectedIds);

                //1464
                this.isLoading = false;

                //2157
                super.listenPatientChange(this.questionnaireId, this.token);
                
                if (this.activePage > this.itemsGroup.length) {
                    this.goNextStep();
                }
            },
            error => {
                alert(this.apiRoute + this.token + '/0/' + this.itemPerPage + ' ----- ' +JSON.stringify(error.message));
            }
            );
        });

        this.subscription = this.translateService.onLangChange.subscribe(value => {
            this.lang = value.lang;
            let data = {
                'questionnaire_id' : this.questionnaireId,
                'language' : value.lang
            }

            this.isLoading = true;
            this.service.changeLanguage(data).subscribe(language => {
                this.isLoading = false;
            });
        });
    }

    ngOnDestroy() {
        super.ngOnDestroy();
    }

    goNextStep() {
        this.allowBack();
        this.router.navigate([this.pageTypes[this.appService.SEType]['route'] + '/' + this.token + '/' + this.pageTypes[this.appService.SEType]['smokeDetector'] + '/2']);
    }

    submitSelection(goNextStep = 0, cb: any = false) {
        this.isLoading = true;

        // On Step 4 : Rating not allowed
        let feelings = {};
        this.service.submit(this.apiUpdateRoute, {
            smoke_detectors: this.selectedIds,
            feelings: feelings,
            is_finish: goNextStep,
            token: this.token,
            is_acute: this.isAcute,
            next_item : (this.itemPerPage * this.activePage) + 1
            // next_page : goNextStep ? this.activePage + 1 : this.activePage
        }).subscribe((rs) => {

            if (rs['success'] && goNextStep) {
                this.nextStep = true;
                this.router.navigate([this.pageTypes[this.appService.SEType]['route'] + '/' + this.token + '/' + this.pageTypes[this.appService.SEType]['smokeDetector'] + '/2']);
            }
            this.isLoading = false;

            if (typeof cb === 'function') {
                cb();
            }
        });
    }

    setIsRedirectedFromAmnestic() {
        this.service.isRedirectedFromAmnestic = true;
    }

}
